<template>
    <div class="modal-body relative  w-full flex flex-col h-full">
      <transition
              enter-active-class="transition duration-400 ease-in"
              enter-from-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="transition duration-100 ease-out"
              leave-from-class="opacity-100"
              leave-to-class="opacity-0"
              class="h-full"
          >
              <div v-if="isLoading" class="fixed top-0 bottom-0 left-0 right-0 bg-black/[0.7] flex flex-col justify-center items-center z-40"
                      tabindex="-1" >
                  <div class="flex flex-col justify-center items-center p-4 rounded-md">
                  <svg aria-hidden="true" class="mx-1 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#d3d3d3"/>
                          <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="#2E9CCA"/>
                  </svg>
                  <div class="text-white p-4 whitespace-nowrap text-sm">
                      Please Wait While We Make Changes To {{ client.client_name }}.
                  </div>
                  </div>
              </div>
          </transition>
        <div class="h-full overscroll-none">
          <div class="h-full ml-3 pb-1 mb-2">
              <div class=" mb-1 flex justify-between items-center h-12">
                  <div class="flex items-center space-x-3 px-1">
                      <h2 class="text-sm tracking-wider font-semibold text-gray-800">Tasks: </h2>
                      <div class="flex space-x-5 w-full justify-start items-center">
                          <div class="flex justify-start items-center w-fit whitespace-nowrap">
                              <div class="mr-1 w-5 h-5 rounded bg-emerald-200 border border-gray-300">
  
                              </div>
                              <div>
                                  Existing Task
                              </div>
                          </div>
                          <div class="flex justify-start items-center w-fit whitespace-nowrap">
                              <div class="mr-1 w-5 h-5 rounded bg-sky-200 border border-gray-300">
  
                              </div>
                              <div>
                                  Valid Row
                              </div>
                          </div>
                          <div class="flex justify-start items-center w-fit whitespace-nowrap">
                              <div class="mr-1 w-5 h-5 rounded bg-red-400 border border-gray-300">
  
                              </div>
                              <div>
                                  Invalid Row
                              </div>
                          </div>
                      </div>
                  </div>
                  <div>
                      <button v-if="showClientTaskEditForm" class="bg-dark-secondary text-white hover:bg-dark-primary px-2 py-1 rounded" @click="closeClientTaskEditForm">Cancel</button>
                      <div v-else class=" flex justify-end items-center space-x-2">
                          <button class="bg-dark-secondary text-white px-2 py-1 rounded" @click="openClientTaskEditForm">Edit Client Tasks</button>
                      </div>
                  </div>
              </div>
              <div class="flex justify-between h-full" v-if="showClientTaskEditForm">
                  <ClientTaskEditForm 
                      :client="client"
                      :client-task-types="clientTaskTypes"
                      :userOptions="userOptions"
                      @update-client-tasks="bulkUpdateClientTasks"
                      @update-client-tasks-and-close="bulkUpdateClientTasksAndClose"
                      @close-client-task-edit-form="closeClientTaskEditForm"
                  />
              </div>
              <div v-else class="h-full">
                  <div class="w-full grid grid-cols-12 border-gray-300 rounded-t overflow-y-scroll ">
                      <div class="w-full bg-gray-50 border-y border-r border-l col-span-1 rounded-tl border-gray-300 px-3 py-1.5 font-semibold">
                          Reorder
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r border-l col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                          Task Type
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r border-l col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                          Task Label
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                          Due Date
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                          Resolved Date
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                          Owner (Created By)
                      </div>
                      <div class="w-full text-center bg-gray-50 border-y border-r col-span-1 border-gray-300 px-3 py-1.5 font-semibold">
                          Status
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                          Notes
                      </div>
                      <div class="w-full bg-gray-50 border-y border-r col-span-2 border-gray-300 px-3 py-1.5 font-semibold">
                          Correspondence
                      </div>
                  </div>
                  <div class="overflow-y-scroll h-96  max-h-[calc(100vh-13.5rem)] ">
                      <TransitionGroup name="tasks">
                          <ClientTaskReadOnlyRow class="draggableRow transition-all duration-100" :ondragstart="dragstartOpenTaskHandler" :ondragend="dragEndHandler" :ondrop="dropOpenTaskHandler"  :ondragover="dragoverOpenTaskHandler" :ondragleave="dragLeaveHandler"
                              draggable="true" :data-value="task.ordinal" :id="task.id" :drag-due-date="task.due_date"
                              v-for="task in openTasks"
                              :key="task.id"
                              :task="task"
                              :is-dragging="isDragging"
                              :dragging-due-date="draggingDueDate"
                          />
                          <ClientTaskReadOnlyRow class="draggableRow transition-all duration-100" :ondragstart="dragstartResolvedTaskHandler" :ondragend="dragEndHandler" :ondrop="dropResolvedTaskHandler"  :ondragover="dragoverResolvedTaskHandler" :ondragleave="dragLeaveHandler"
                              draggable="true" :data-value="task.ordinal" :id="task.id" :drag-resolved-date="task.resolved_date"
                              v-for="task in resolvedTasks"
                              :key="task.id"
                              :task="task"
                              :is-dragging="isDragging"
                              :dragging-resolved-date="draggingResolvedDate"
                          />
                      </TransitionGroup>
                  </div>
              </div>
          </div>
        </div>
    </div>
  </template>
  
  <!-- <style>
  .eventTable-enter-active,
  .eventTable-leave-active {
    transition: all 0.5s ease;
  }
  .eventTable-enter-from,
  .eventTable-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
  </style> -->
  
  <script setup>
  import { defineProps, ref, computed, watch, defineEmits, onMounted} from 'vue';
  import { useStore } from 'vuex';
  import {deleteTask, bulkUpdateOrdinals } from '@/services/ClientTask.js'
//   import { getUsers } from '@/services/User';
  import ClientTaskEditForm from './ClientTaskEditForm.vue';
  import ClientTaskReadOnlyRow from './ClientTaskReadOnlyRow.vue';
  import { updateClientTasks } from '@/services/Client';
  import { useToast } from 'vue-toast-notification';
  
  const store = useStore()
  const $toast = useToast()
  
  const props = defineProps(['client', 'clientTaskTypes', 'openInEdit', 'userOptions'])
  
  const emit = defineEmits(['refetch-clients', 'updated', 'close', 'loading-client', 'client-loaded', 'save-and-close'])
  
  const formRows = ref([])
  
  const showClientTaskEditForm = ref(props.openInEdit)
  
  const isLoading = ref(false)
  
//   const showOnSpreadsheetView = ref(props.company ? !!props.company.show_on_spreadsheet_view : false)
  
  watch(() => props.openInEdit, () => {
      if(props.openInEdit){
          openClientTaskEditForm()
      }
  })
  
  
//   const userOptions = ref([
//       {value: null, label: 'None'}
//   ])
  
  function openClientTaskEditForm() {
      showClientTaskEditForm.value = true
  }
  
  function closeClientTaskEditForm() {
      showClientTaskEditForm.value = false
  }

  function sortByResolvedDate(a, b){
      if(a.resolved_date && b.resolved_date){
          if(a.resolved_date == b.resolved_date){
              return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
          } else {
              return new Date(b.resolved_date) - new Date(a.resolved_date)
          }
      } else if ((a.resolved_date && !b.resolved_date)){
          return -1
      } else if ((b.resolved_date && !a.resolved_date)){
          return 11
      } else {
          return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
      }
  }
  
  const resolvedTasks = ref([])
  
  function setResolvedTasks(){
      let completedTaskList = props.client.tasks.filter(task => task.resolved_date).sort(sortByResolvedDate)
      resolvedTasks.value = completedTaskList
  }
  
  setResolvedTasks()
  
  function sortByDueDate(a, b){
      if(a.due_date && b.due_date){
          if(a.due_date == b.due_date){
              return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
          } else {
              return new Date(a.due_date) - new Date(b.due_date)
          }
      } else if ((a.due_date && !b.due_date)){
          return 1
      } else if ((b.due_date && !a.due_date)){
          return -1
      } else {
          return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
      }
  }
  
  const openTasks = ref([])
  
  
  function setOrdinals(){
      for(let i = 0; i < openTasks.value.length; i++){
          openTasks.value[i].ordinal = i
      }
      for(let i = 0; i < resolvedTasks.value.length; i++){
          resolvedTasks.value[i].ordinal = i
      }
  }
  
  function setOpenTasks() {
      let openTaskList = props.client.tasks.filter(task => !task.resolved_date).sort(sortByDueDate)
      openTasks.value =  openTaskList
      setOrdinals()
  }
  
  setOpenTasks()
  
  watch(() => props.client, () => {
      setOpenTasks()
      setResolvedTasks()
  })
  
  function validateClientTaskRows(taskRows) {
      let invalidClientTaskRows = []
      let validClientTaskRows = []
      for(let taskRow of taskRows) {
          if(taskRow.task_type_id) {
              validClientTaskRows.push(taskRow)
          } else {
              invalidClientTaskRows.push(taskRow)
          }
      }
      if(invalidClientTaskRows.length > 0) {
          alert(`Validation Error: Found ${invalidClientTaskRows.length} invalid row(s). Please fix before continuing.`)
          return null
      }
      return validClientTaskRows
  }
  
  async function bulkUpdateClientTasks(clientTasks) {
      isLoading.value = true 
      let taskRows = validateClientTaskRows(clientTasks)
      if(taskRows) {
          const payload = {
              token: store.state.auth.token,
              formData: JSON.stringify(
              {
                  client_tasks: taskRows
              }),
              clientId: props.client.id
          }
          const response = await updateClientTasks(payload)
          closeClientTaskEditForm()
          if(response.status == 200) {
              fetchNewClients()
              emit('updated')
              $toast.open({
                  message: `Successfully Updated Tasks for ${props.client.client_name}.`,
                  type: 'success',
                  duration: 5000
              })
          } else {
              $toast.open({
                  message: `Unable to Update Tasks ${props.client.client_name}`,
                  type: 'error',
                  duration: 20000
              })
          }
      } else {
          isLoading.value = false
      }
  
  }
  
  async function updateTasksOrdinals(clientTasks){
      const token = store.state.auth.token
      const data = {
          client_tasks: clientTasks
      }
      const result = await bulkUpdateOrdinals(data, token)
      if(result.status == 200){
          return
      } else {
          $toast.open({
              message: "Error, could not re-order details",
              type: "error",
              duration: 3000
          })
      }
  
  }
  
  async function bulkUpdateClientTasksAndClose(clientTasks) {
      console.log('save and close')
      // isLoading.value = true 
      // console.log('bulkUpdateClientTasks', props.company.id)
      let taskRows = validateClientTaskRows(clientTasks)
      
      if(taskRows) {
          emit('save-and-close', taskRows)
      } else {
          isLoading.value = false
      }
  
  }
  
  function fetchNewClients(){
      isLoading.value = true
      emit('refetch-clients')
  }
  
  watch(props, () => {
      if(props.client){
          isLoading.value = false
      }
  })
  
//   async function setUserOptions() {
//       let payload = {
//           token: store.state.auth.token,
//           endpoint: '?group_id=1&group_id=7&group_id=8&exclude_dev=True&is_active=True'
//       }
//       const result = await getUsers(payload)
//       userOptions.value = [{value: null, label: 'None'}, ...result.users.map((user) => {
//           return { value: user.id, label: `${user.first_name} ${user.last_name}`}
//       })]
//   }
  
//   async function saveShowOnSpreadsheetView(){
//       const token = store.state.auth.token
//       console.log('should show?', showOnSpreadsheetView.value)
//       isLoading.value = true
//       const formData = {
//           show_on_spreadsheet_view: showOnSpreadsheetView.value ? 1.0000000000000000 : null
//       }
//       const response = await updateCompany(props.company.id, formData, token)
//       if(response.status == 200) {
//           emit('refetch-companies')
//           $toast.open({
//               message: `Successfully Updated Show on Spreadsheet View for ${props.company.company_name}.`,
//               type: 'success',
//               duration: 5000
//           })
//       }
//       isLoading.value = false
  
//   }
  
  const isDragging = ref(false)
  const draggingId = ref(null)
  const draggingDueDate = ref(null)
  const draggingResolvedDate = ref(null)
  
  function dragoverOpenTaskHandler(ev) {
      ev.preventDefault();
      let target = ev.currentTarget
      const targetDueDate = target.getAttribute("drag-due-date")
      if(targetDueDate == draggingDueDate.value){
          target.classList.add("border")
          target.classList.add("border-dark-primary")
          const currentDragElementOffset = ev.clientY
          const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
          const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
          if(currentDragElementOffset < targetDragElementOffset){
              ev.currentTarget.classList.add("translate-y-2")
          }
          if(currentDragElementOffset > targetDragElementOffset){
              ev.currentTarget.classList.add("-translate-y-2")
          }
      }
      ev.dataTransfer.dropEffect = "move"
    }
  
  function dragoverResolvedTaskHandler(ev) {
      ev.preventDefault();
      let target = ev.currentTarget
      const targetResolvedDate = target.getAttribute("drag-resolved-date")
      if(targetResolvedDate == draggingResolvedDate.value){
          target.classList.add("border")
          target.classList.add("border-dark-primary")
          const currentDragElementOffset = ev.clientY
          const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
          const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
          if(currentDragElementOffset < targetDragElementOffset){
              ev.currentTarget.classList.add("translate-y-2")
          }
          if(currentDragElementOffset > targetDragElementOffset){
              ev.currentTarget.classList.add("-translate-y-2")
          }
      }
      ev.dataTransfer.dropEffect = "move"
    }
  
  function dragLeaveHandler(ev) {
      ev.preventDefault();
      let target = ev.currentTarget
      target.classList.remove("border")
      target.classList.remove("border-dark-primary")
      target.classList.remove("translate-y-2")
      target.classList.remove("-translate-y-2")
    }
  
    function dropOpenTaskHandler(ev) {
      ev.preventDefault();
      isDragging.value = false
      const currentDragElementOffset = ev.clientY
      const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
      const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
      const targetCrmOrdinal = ev.currentTarget.getAttribute("data-value")
      const targetId = ev.currentTarget.getAttribute("id")
      let data = ev.dataTransfer.getData("text/plain");
      data = JSON.parse(data)
      let draggingRow = props.client.tasks.find((row) => row.id == data.taskId)
      let dropRow = props.client.tasks.find((row) => row.id == ev.currentTarget.id)
      if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
          let openTask = openTasks.value.find((row) => row.id == data.taskId)
          if(openTask){
              // ev.currentTarget.classList.add("translate-y-2")
              let draggingRowIdx = openTasks.value.findIndex((row) => row.id == data.taskId)
              openTasks.value.splice(draggingRowIdx, 1)
              let dropRowIdx = openTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
              openTasks.value.splice(dropRowIdx, 0, openTask)
          }
      } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && (draggingRow.due_date == dropRow.due_date || (!draggingRow.due_date && !dropRow.due_date))){
          let openTask = openTasks.value.find((row) => row.id == data.taskId)
          if(openTask){
              // ev.currentTarget.classList.add("-translate-y-2")
              let draggingRowIdx = openTasks.value.findIndex((row) => row.id == data.taskId)
              openTasks.value.splice(draggingRowIdx, 1)
              let dropRowIdx = openTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
              openTasks.value.splice(dropRowIdx + 1, 0, openTask)
          }
      }
      setOrdinals()
      draggingId.value = null
      ev.currentTarget.classList.remove('border')
      ev.currentTarget.classList.remove('border-dark-primary')
      ev.currentTarget.classList.remove("translate-y-2")
      ev.currentTarget.classList.remove("-translate-y-2")
      updateTasksOrdinals(openTasks.value)
    }
  
    function dropResolvedTaskHandler(ev) {
      ev.preventDefault();
      isDragging.value = false
      const currentDragElementOffset = ev.clientY
      const targetDragElementRectangle = ev.currentTarget.getBoundingClientRect()
      const targetDragElementOffset = targetDragElementRectangle.y + (targetDragElementRectangle.height / 2)
      const targetCrmOrdinal = ev.currentTarget.getAttribute("data-value")
      const targetId = ev.currentTarget.getAttribute("id")
      let data = ev.dataTransfer.getData("text/plain");
      data = JSON.parse(data)
      let draggingRow = props.client.tasks.find((row) => row.id == data.taskId)
      let dropRow = props.client.tasks.find((row) => row.id == ev.currentTarget.id)
      if(draggingRow.id != dropRow.id && currentDragElementOffset < targetDragElementOffset && draggingRow.resolved_date == dropRow.resolved_date){
          let resolvedTask = resolvedTasks.value.find((row) => row.id == data.taskId)
          if(resolvedTask){
              // ev.currentTarget.classList.add("translate-y-2")
              let draggingRowIdx = resolvedTasks.value.findIndex((row) => row.id == data.taskId)
              resolvedTasks.value.splice(draggingRowIdx, 1)
              let dropRowIdx = resolvedTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
              resolvedTasks.value.splice(dropRowIdx, 0, resolvedTask)
          }
      } else if(draggingRow.id != dropRow.id && currentDragElementOffset > targetDragElementOffset && draggingRow.resolved_date == dropRow.resolved_date){
          let resolvedTask = resolvedTasks.value.find((row) => row.id == data.taskId)
          if(resolvedTask){
              // ev.currentTarget.classList.add("-translate-y-2")
              let draggingRowIdx = resolvedTasks.value.findIndex((row) => row.id == data.taskId)
              resolvedTasks.value.splice(draggingRowIdx, 1)
              let dropRowIdx = resolvedTasks.value.findIndex((row) => row.id == ev.currentTarget.id)
              resolvedTasks.value.splice(dropRowIdx + 1, 0, resolvedTask)
          }
      }
      setOrdinals()
      draggingId.value = null
      ev.currentTarget.classList.remove('border')
      ev.currentTarget.classList.remove('border-dark-primary')
      ev.currentTarget.classList.remove("translate-y-2")
      ev.currentTarget.classList.remove("-translate-y-2")
      updateTasksOrdinals(resolvedTasks.value)
    }
  
  function dragstartOpenTaskHandler(ev) {
      draggingId.value = ev.target.id
      isDragging.value = true
      ev.dataTransfer.effectAllowed = "move";
      ev.dataTransfer.dropEffect = "move"
      const taskOrdinal = ev.target.getAttribute('data-value')
      let draggingRow = props.client.tasks.find((row) => row.id == ev.target.id)
      draggingDueDate.value = draggingRow.due_date
      ev.dataTransfer.setData("text/plain", JSON.stringify({taskId: ev.target.id, taskOrdinal: taskOrdinal}));
  }
  
  function dragstartResolvedTaskHandler(ev) {
      draggingId.value = ev.target.id
      // const companyId = ev.target.id
      isDragging.value = true
      // console.log('drag starting with id', ev.target.id)
      ev.dataTransfer.effectAllowed = "move";
      ev.dataTransfer.dropEffect = "move"
      const taskOrdinal = ev.target.getAttribute('data-value')
      let draggingRow = props.client.tasks.find((row) => row.id == ev.target.id)
      draggingResolvedDate.value = draggingRow.resolved_date
      ev.dataTransfer.setData("text/plain", JSON.stringify({crmDetailId: ev.target.id, taskOrdinal: taskOrdinal}));
  }
  
  function dragEndHandler(ev) {
      // console.log('drag ended')
      isDragging.value = false
      draggingId.value = null
      draggingDueDate.value = null
      draggingResolvedDate.value = null
      ev.currentTarget.classList.remove('border')
      ev.currentTarget.classList.remove('border-dark-primary')
      ev.currentTarget.classList.remove("translate-y-2")
      ev.currentTarget.classList.remove("-translate-y-2")
  }

//   setUserOptions()
  </script>
  
  <style scoped>
  .tasks-move,
  .tasks-enter-active {
      transition: all 0.1s ease;
  }
  .tasks-leave-active {
    transition: all 0.08s ease;
  }
  .tasks-enter-from,
  .tasks-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }
  
  .tasks-leave-active {
      position: relative;
      /* position: relative; */
  }
  </style>